import React from 'react'
import {
  CFImage,
  CFLink,
  CFSelect,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { locationMap, mobileMap } from 'images'
import { dispatch } from 'store'

export default () => {
  return (
    <CFSelect selector={dispatch.restaurant.getSelectedLocationId}>
      {locationId => (
        <CFView>
          <MobileScreen>
            <CFLink href="https://goo.gl/maps/wYnvwQRNuQ1RbP287">
              <CFImage
                src={mobileMap}
                w="100%"
                alt="Aburiya SushiJapanese Cuisine"
              />
            </CFLink>
          </MobileScreen>
          <DefaultScreen>
            <CFLink href="https://goo.gl/maps/wYnvwQRNuQ1RbP287">
              <CFImage
                src={locationMap}
                w="100%"
                alt="Aburiya SushiJapanese Cuisine"
              />
            </CFLink>
          </DefaultScreen>
        </CFView>
      )}
    </CFSelect>
  )
}
